ht.refreshPage = function () {
  location.reload(true);
};
